import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push as routerPush } from 'react-router-redux';
import injectSheet from 'react-jss';
import moment from 'moment';
import IconWithCounter from './icon-with-counter';
import Avatar from 'material-ui/Avatar';
import FlatButton from 'material-ui/FlatButton';
import { fullWhite, pinkA200 } from 'material-ui/styles/colors';
import AcceptIcon from 'material-ui/svg-icons/navigation/check';
import DenyIcon from 'material-ui/svg-icons/navigation/close';
import PeopleIcon from 'material-ui/svg-icons/social/people';

import PopoverList from './popover-list.jsx';
import { removeConnectionFromStatus } from '../../workspace/store/actions';
import { markAcceptedRead } from '../../workspace/store/actions';
import {
  acceptConnection,
  ignoreConnection,
} from '../../../stores/connections/connections-actions';

const { NEW_SYSTEM_URL } = process.env;

class ConnectionNotification extends React.Component {
  setIcon = item => {
    const leftIcon = (() => {
      '';
      if (item.profileImageUrl) {
        return <Avatar className={this.props.classes.avatar} src={item.profileImageUrl} />;
      }
      return (
        <Avatar className={this.props.classes.avatar}>
          {(item.otherSideName || '?')[0].toUpperCase()}
        </Avatar>
      );
    })();
    return {
      ...item,
      leftIcon,
    };
  };
  connectionAction = (itemId, actionType) => () => {
    this.props.removeConnectionFromStatus(itemId);
    ({
      accept: () => this.props.acceptConnection(itemId),
      deny: () => this.props.ignoreConnection(itemId),
    }[actionType]());
  };
  render() {
    const { routerPush: push, pendingConnections, unreadAccepted } = this.props;
    return (
      <PopoverList
        list={pendingConnections
          .map(
            ({
              _id: id,
              created_at: timestamp,
              message: text,
              profileImageUrl,
              sender_company_name: otherSideName,
              sender_id: senderId,
            }) => ({
              id,
              otherSideName,
              firstRowAction: () => {
                push(`/company/${senderId}`);
              },
              profileImageUrl,
              text,
              forSort: moment(timestamp).unix(),
              timestamp,
              itemActions: [
                <FlatButton
                  key={`deny-${id}`}
                  label="Reject"
                  labelPosition="after"
                  backgroundColor={pinkA200}
                  hoverColor={pinkA200}
                  icon={<DenyIcon color={fullWhite} style={{ width: '1.5em', height: '1.5em' }} />}
                  labelStyle={{ fontSize: '1em', textTransform: 'none', color: 'white' }}
                  onTouchTap={this.connectionAction(id, 'deny')}
                  style={{
                    lineHeight: '2em',
                    height: '2.5em',
                    marginTop: '0.5em',
                    fontSize: '0.8em',
                    marginRight: '1em',
                  }}
                />,
                <FlatButton
                  key={`accept-${id}`}
                  label="Accept"
                  labelPosition="after"
                  icon={
                    <AcceptIcon color={fullWhite} style={{ width: '1.5em', height: '1.5em' }} />
                  }
                  labelStyle={{ fontSize: '1em', textTransform: 'none', color: 'white' }}
                  onTouchTap={this.connectionAction(id, 'accept')}
                  backgroundColor="#008000"
                  hoverColor="#008000"
                  style={{
                    lineHeight: '2em',
                    height: '2.5em',
                    marginRight: '1em',
                    marginTop: '0.5em',
                    fontSize: '0.8em',
                  }}
                />,
              ],
            }),
          )
          .concat(
            unreadAccepted.map(
              ({ connectionId: id, partnerId, companyName: otherSideName, profileImageUrl, timestamp }) => ({
                id,
                otherSideName,
                profileImageUrl,
                clickItem: () => {
                  this.props.markAcceptedRead([id]);
                  if (partnerId) {
                    window.location.href = `${NEW_SYSTEM_URL}/partner-management/partner-details/${partnerId}?jwt=${localStorage.getItem('jwt')}`;
                  } else {
                    push(`/connections/connected?id=${id}`);
                  }
                },
                unread: true,
                text: 'Accepted your partner request.',
                forSort: moment(timestamp).unix(),
                timestamp,
              }),
            ),
          )
          .sort((a, b) => -a.forSort + b.forSort)
          .slice(0, 100)
          .map(this.setIcon)}
        title="Partner Requests"
        bottomRightText="Find Partners"
        bottomRightAction={() => {
          push('/partner-finder/results');
        }}
        bottomLeftText="Partners"
        bottomLeftAction={() => {
          window.location.href = `${NEW_SYSTEM_URL}/partner-management/partner-list/partner`;
        }}
        topRightSecondaryText={`Clear Accepted Notifications`}
        topRightSecondaryAction={
          unreadAccepted.length
            ? () => this.props.markAcceptedRead(unreadAccepted.map(obj => obj.connectionId))
            : null
        }
      >
        <IconWithCounter
          style={{ display: 'flex', marginLeft: '25px', minWidth: '50px' }}
          icon={<PeopleIcon />}
          count={pendingConnections.length + unreadAccepted.length}
        />
      </PopoverList>
    );
  }
}

ConnectionNotification.propTypes = {
  acceptConnection: PropTypes.func,
  classes: PropTypes.object,
  ignoreConnection: PropTypes.func,
  markAcceptedRead: PropTypes.func,
  pendingConnections: PropTypes.array,
  removeConnectionFromStatus: PropTypes.func,
  routerPush: PropTypes.func,
  unreadAccepted: PropTypes.array,
};

const mapStateToProps = ({ workspace: { pendingConnections, unreadAccepted } }) => ({
  pendingConnections,
  unreadAccepted,
});

export default connect(mapStateToProps, {
  acceptConnection,
  ignoreConnection,
  removeConnectionFromStatus,
  routerPush,
  markAcceptedRead,
})(
  injectSheet({
    avatar: {
      border: 'solid 1px #bbb',
      height: '40px !important',
      lineHeight: '37px',
      marginTop: '6px !important',
      textAlign: 'center',
      width: '40px !important',
      color: 'white !important',
    },
    iconStyle: {
      color: 'rgba(0, 0, 0, 0.44) !important',
    },
  })(ConnectionNotification),
);



// WEBPACK FOOTER //
// ./src/app/components/app-bar/notification/connections.jsx